import { FC } from 'react';
import { ReactComponent as Logo } from 'assets/logo.svg';
import { HStack, BentoMenu } from '@montel/montelpro-shared-components-v2';
import { StyledHeaderBar, StyledHeaderBarContent } from './styles';
import Profile from './Profile/Profile';
import { useTheme } from 'styled-components';
import { bentoNavigationLinks } from 'App/configs/bentoConfig';
import StyledLink from 'components/common/Link';

interface HeaderProps {
	breakpoint?: string;
	className?: string;
	showProfile?: boolean;
}

const Header: FC<HeaderProps> = ({
	breakpoint = 'lg',
	showProfile = true,
	className,
}) => {
	const { colors } = useTheme();
	return (
		<StyledHeaderBar $breakpoint={breakpoint} className={className}>
			<StyledHeaderBarContent $breakpoint={breakpoint}>
				<HStack align="center">
					<BentoMenu navigationItems={bentoNavigationLinks} />
					<StyledLink to="/">
						<Logo color={colors.textDefault} />
					</StyledLink>
				</HStack>
				{showProfile && <Profile breakpoint={breakpoint} />}
			</StyledHeaderBarContent>
		</StyledHeaderBar>
	);
};

export default Header;
